export default (date: Date) => {
  const IsoString = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  ).toISOString();
  return IsoString;
};
